/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const initialState = {
  performDisputeResolutionObj: {},
  planType: [],
  rebateProgram: [],
  dramsInvoice: '',
  stateFiscal: '',
  rebateProgramName: {},
  timePeriod: 'Quarter',
  year: 'Calendar',
  planTypeCD: '',
  rebateProgramCD: '',
  searchScreenObj: {
    timePeriod: 'Quarter',
    year: 'Calendar',
    planTypeCD: '',
    rebateProgramCD: '',
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ERROR_MSG_REBATE_SUMMARY:
      return { ...state, errorMsgRebateSummary: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_REBATE_SUMMARY_INVOICED:
      return { ...state, rebateInvoiced: action.payload };
    case actionTypes.GET_REBATE_SUMMARY_DISPUTE:
      return { ...state, rebateDispute: action.payload };
    case actionTypes.GET_REBATE_SUMMARY_PAYMENT_RECEIVED:
      return { ...state, rebatePayment: action.payload };
    case actionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE:
      return { ...state, dramsInvoice: action.payload };
    case actionTypes.DISPLAY_STATE_FISCAL:
      return { ...state, stateFiscal: action.payload };
    case actionTypes.SET_SEARCH_SCREEN_OBJ_DATA_RBT_SUMM:
      return { ...state, searchScreenObj: action.searchScreenObj };
    case actionTypes.SET_REFRESH_DATA_REBATE:
      return {
        ...initialState,
      };
    case actionTypes.GET_REBATE_PROGRAM_NAME:
      return { ...state, ...action.payload };
    case actionTypes.SET_RBT_SUMM_TBL_DATA:
      return { ...state, rebateSummaryTblData: action.payload };
    default:
      return state;
  }
};

export default reducer;
